export default function getToProp(to, path = "") {
    if (to !== null && typeof to === "object") {
        return {
            ...to,
            pathname: `${path}${to.pathname}`,
        };
    }
    return `${path}${to}`;
}
